import { hbs } from 'ember-cli-htmlbars';
export default hbs("{{page-title \"Cardstack\"}}\n\n{{outlet}}")